import { useCallback, useState } from 'react';
import { useApi } from '#shared/providers/Api';
import unwrap from './unwrap';
import { UserRow, UsersAccount, UsersViewer } from './types';

type UseUsersListOptions = Pick<UsersViewer, 'timezone'> & Pick<UsersAccount, 'bearer'>;

// The user list and its fetch. Rejects on failure so the caller decides how to surface it. Takes its
// inputs as options rather than reading the feature context: the provider calls it to seed that context.
export default function useUsersList({ timezone, bearer }: UseUsersListOptions) {
  const api = useApi();
  const [users, setUsers] = useState<UserRow[]>([]);
  const [fetchingUsers, setFetchingUsers] = useState(false);

  const fetchUsers = useCallback(async () => {
    try {
      setFetchingUsers(true);
      const res = await unwrap(api.fetchAccountUsers({ Timezone: timezone }, bearer));
      setUsers(res.Users);
    } finally {
      setFetchingUsers(false);
    }
  }, [api, timezone, bearer]);

  return { users, fetchingUsers, fetchUsers };
}
